<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalQuotationVisible" :vm-is-valid="!$v.newRecord.$invalid" vm-title='Create Quotation')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.quotation_start_date")' :danger="!!$v.newRecord.quotation_start_date.$invalid && !!$v.newRecord.quotation_start_date.$model" :danger-text="$t('validation.required', { attribute: $t('projects.quotation_start_date') })" v-model="newRecord.quotation_start_date")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.quotation_delivery_date")' :danger="!!$v.newRecord.quotation_delivery_date.$invalid && !!$v.newRecord.quotation_delivery_date.$model" :danger-text="$t('validation.required', { attribute: $t('projects.quotation_delivery_date') })" v-model="newRecord.quotation_delivery_date")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(:placeholder='$t("projects.comments_placeholder")'  v-model="newRecord.comments_quotation" type="text" :label='$t("projects.comments")')
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ToQuotes')

export default {
  name: 'ModalQuotation',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      quotation_start_date: {
        required
      },
      quotation_delivery_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalQuotationVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalQuotationVisible',
      'addQuotation'
    ]),
    saveRecord () {
      this.addQuotation(this.newRecord)
    },
    close () {
      this.setModalQuotationVisible(false)
    }
  }
}
</script>
<style lang="scss">
/* .con-vm-dialog {
  .vm-dialog {
    background: #ffffff21 !important;
  }
} */
</style>
